export default __webpack_public_path__ + "static/media/49.6b824868.svg";